import { onBeforeUnmount, onMounted } from 'vue';
import { useUiStore } from '@/stores/uiStore';

export function useGlobalShortcuts(): void {
  const ui = useUiStore();

  function onKeydown(e: KeyboardEvent): void {
    const isMac = navigator.platform.toLowerCase().includes('mac');
    const cmdOrCtrl = isMac ? e.metaKey : e.ctrlKey;
    if (cmdOrCtrl && e.key.toLowerCase() === 'k') {
      e.preventDefault();
      ui.toggleCopilot();
    }
  }

  onMounted(() => window.addEventListener('keydown', onKeydown));
  onBeforeUnmount(() => window.removeEventListener('keydown', onKeydown));
}
